import { Outlet } from 'react-router';

import { ROUTING_PATHS } from 'const';
import { BreadcrumbRouteObject } from 'types';

const { users } = ROUTING_PATHS;
export const USERS_ROUTES: BreadcrumbRouteObject[] = [
  {
    path: users.path,
    breadcrumb: { text: 'Users', icon: 'users' },
    element: <Outlet />,
    children: [
      {
        index: true,
        lazy: () => import('./users-list'),
      },
      {
        path: users.add.path,
        breadcrumb: { text: 'Add User', icon: 'user plus' },
        lazy: () => import('./user-add'),
      },
      {
        path: users.details.path,
        breadcrumb: { text: 'User Details', icon: 'user' },
        lazy: () => import('./user-details'),
      },
    ],
  },
];
